'use strict';

var style = require('../style/style.cjs');
var compose = require('../compose/compose.cjs');

function paletteTransform(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }
  return value;
}
const color = style.default({
  prop: 'color',
  themeKey: 'palette',
  transform: paletteTransform
});
const bgcolor = style.default({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const backgroundColor = style.default({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
compose(color, bgcolor, backgroundColor);

exports.backgroundColor = backgroundColor;
exports.bgcolor = bgcolor;
exports.color = color;
exports.paletteTransform = paletteTransform;
//# sourceMappingURL=palette.cjs.map
